import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["emojiProvider"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */

import { jsx } from '@emotion/react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { ufoExperiences } from '../../util/analytics';
import LoadingEmojiComponent from '../common/LoadingEmojiComponent';
import { LoadingItem } from './EmojiPickerVirtualItems';
import { emojiPicker } from './styles';
import { UfoErrorBoundary } from '../common/UfoErrorBoundary';
import { defaultEmojiPickerSize } from '../../util/constants';
import { EmojiCommonProvider } from '../../context/EmojiCommonProvider';
var emojiPickerModuleLoader = function emojiPickerModuleLoader() {
  return import( /* webpackChunkName:"@atlaskit-internal_emojiPickerComponent" */'./EmojiPickerComponent');
};
var emojiPickerLoader = function emojiPickerLoader() {
  return emojiPickerModuleLoader().then(function (module) {
    return module.default;
  });
};
export var EmojiPickerInternal = /*#__PURE__*/function (_LoadingEmojiComponen) {
  _inherits(EmojiPickerInternal, _LoadingEmojiComponen);
  var _super = _createSuper(EmojiPickerInternal);
  function EmojiPickerInternal(props) {
    var _this;
    _classCallCheck(this, EmojiPickerInternal);
    _this = _super.call(this, props, {});
    _defineProperty(_assertThisInitialized(_this), "state", {
      asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent
    });
    ufoExperiences['emoji-picker-opened'].start();
    return _this;
  }
  _createClass(EmojiPickerInternal, [{
    key: "asyncLoadComponent",
    value: function asyncLoadComponent() {
      var _this2 = this;
      emojiPickerLoader().then(function (component) {
        EmojiPickerInternal.AsyncLoadedComponent = component;
        _this2.setAsyncState(component);
      });
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      var _this3 = this;
      var item = new LoadingItem();
      var handlePickerRef = function handlePickerRef(ref) {
        if (_this3.props.onPickerRef) {
          _this3.props.onPickerRef(ref);
        }
      };
      ufoExperiences['emoji-picker-opened'].markFMP();
      return jsx("div", {
        css: emojiPicker(),
        ref: handlePickerRef
      }, item.renderItem());
    }
  }, {
    key: "renderLoaded",
    value: function renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
      var _this$props = this.props,
        emojiProvider = _this$props.emojiProvider,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return jsx(UfoErrorBoundary, {
        experiences: [ufoExperiences['emoji-picker-opened']]
      }, jsx(EmojiCommonProvider, {
        emojiProvider: loadedEmojiProvider
      }, jsx(EmojiPickerComponent, otherProps)));
    }
  }]);
  return EmojiPickerInternal;
}(LoadingEmojiComponent);
// state initialised with static component to prevent
// rerender when the module has already been loaded
_defineProperty(EmojiPickerInternal, "defaultProps", {
  size: defaultEmojiPickerSize
});
var EmojiPicker = withAnalyticsEvents()(EmojiPickerInternal);
export default EmojiPicker;